<!--Main-->
<template>
  <el-row :gutter="10" style="height：auto">
    <el-col :span="24">
      <el-card
        :shadow="shadow ? 'always' : 'never'"
        :class="!border && 'no-border'"
      >
        <div v-if="topHandle" class="panel-title">
          <div v-if="topHandle.title" class="title">
            {{ $t(topHandle.title) }}
          </div>
          <vxe-toolbar v-if="topHandle.btList">
            <template v-slot:buttons>
              <el-button
                v-for="(bt, index) in topHandle.btList"
                v-waves
                :key="index"
                :type="bt.type"
                :icon="bt.icon"
                :disabled="bt.disabled"
                :loading="bt.loading"
                :size="bt.size"
                @click="handleClick(bt.event)"
                >{{ $t(bt.label) }}</el-button
              >
            </template>
          </vxe-toolbar>
          <vxe-toolbar v-if="topHandle.fieldList">
            <template v-slot:buttons>
              <el-input
                v-for="(field, index) in topHandle.fieldList"
                :key="index"
                v-model="topHandle.data[field.prop]"
                :placeholder="$t(field.placeholder)"
                clearable
                @input="handleClick(field.event)"
              ></el-input>
            </template>
          </vxe-toolbar>
        </div>
        <vxe-table
          v-if="data"
          ref="vexForm"
          resizable
          border
          show-overflow
          auto-resize
          row-id="rowid"
          style="width: 100%"
          keep-source
          :loading="loading"
          :height="height"
          :edit-config='editConfig'
          :edit-rules="rules"
          :data.sync="data"
          @checkbox-all="checkboxChange"
          @checkbox-change="checkboxChange"
          @edit-actived="editActivedEvent"
          @edit-closed="editClosedEvent"
          @cell-click="cellClickEvent"
        >
          <vxe-table-column
            v-for="column in fieldList"
            header-align="left"
            align="left"
            :field="column.prop"
            :title="$t(column.label)"
            :width="column.width"
            :min-width="column.minWidth"
            :fixed="column.fixed"
            :key="column.prop"
            :type="column.type"
            :formatter="column.formatter"
            :edit-render="column.edit"
            :cell-render="column.cell"
            show-overflow-tooltip
            show-overflow
          >
            <!-- header -->
            <template slot="header" slot-scope="scope">
              <el-button
                v-if="column.btType == 'create'"
                type="info"
                class="el-icon-plus"
                size="mini"
                :disabled="column.disabled"
                @click="handleClick(column.addEvent, scope)"
              />
              <template v-else>
                {{ $t(column.label) }}
              </template>
            </template>
            <!-- column -->
            <template v-if="column.btType == 'link'" v-slot="scope">
              <el-link
                :underline="false"
                :type="column.type"
                @click="
                  handleClick(column.event, {
                    ...scope.row,
                    $rowIndex: scope.$rowIndex,
                  })
                "
              >
                {{ scope.row[column.prop] }}
              </el-link>
            </template>
            <template v-else-if="column.btType == 'create'" slot-scope="scope">
              <el-button
                v-if="data.length > 0"
                size="mini"
                type="danger"
                class="el-icon-minus"
                :disabled="column.disabled || scope.row['removeDisabled']"
                @click="handleClick(column.removeEvent, scope.$rowIndex)"
              />
            </template>
            <template v-else-if="column.btType == 'radio'" slot-scope="scope">
              <el-radio v-model="scope.row[column.prop]" :label="true">{{
                $t("table.yes")
              }}</el-radio>
              <el-radio v-model="scope.row[column.prop]" :label="false">{{
                $t("table.no")
              }}</el-radio>
            </template>
            <template v-else-if="column.btType == 'button'" slot-scope="scope">
              <el-button
                v-if="scope.row.btShow"
                size="mini"
                type="primary"
                :disabled="column.disabled"
                @click="handleClick(column.event, scope)"
                >{{ scope.row[column.prop] || $t(column.btLabel) }}</el-button
              >
              <template else>
                {{ scope.row[column.prop] }}
              </template>
            </template>
            <template v-else-if="column.btType == 'add'" slot-scope="scope">
              <el-link
                icon="el-icon-circle-plus"
                style="color: #9ccec1"
                :disabled="column.disabled"
                :underline="false"
                @click="handleClick(column.event, scope)"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-if="tabHandle !== null"
            :key="'tabHandle'"
            :fixed="tabHandle.fixed"
            align="center"
            :title="$t(tabHandle.label)"
            :width="tabHandle.width"
          >
            <template v-slot="scope">
              <template v-for="(item, index) in tabHandle.btList">
                <!-- 自定义操作类型 -->
                <slot
                  v-if="item.slot"
                  :name="'bt-' + item.event"
                  :data="{ item, row: scope.row }"
                />
                <!-- 操作按钮 -->
                <el-tooltip
                  v-if="item.show"
                  :key="index"
                  class="item"
                  :content="$t(item.label)"
                  placement="bottom-start"
                >
                  <el-link
                    plain
                    size="mini"
                    :type="item.type"
                    :icon="item.icon"
                    @click="
                      handleClick(item.event, {
                        ...scope.row,
                        $rowIndex: scope.$rowIndex,
                      })
                    "
                  />
                </el-tooltip>
              </template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "Main",
  computed: {},
  props: {
    loading: {
      type: Boolean
    },
    // 列表数据
    data: {
      type: Array,
    },
    // 验证规则
    rules: {
      type: Object,
    },
    refObj: {
      type: Object,
    },
    topBtn: {
      type: Object,
    },
    // 表格字段配置
    fieldList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    height: String,
    editConfig: {
      type: Object,
      default: () => {
        return { "row-id": "row-id", trigger: "click", mode: "row" }
      }
    },
    checkboxChangeEvent: {
      type: String,
    },
    // 操作栏配置
    topHandle: {
      type: Object,
    },
    tabHandle: {
      type: Object,
    },
    maxHeight: {
      type: Number,
      default: 500,
    },
    size: {
      type: String,
      default: "mini",
    },
    editActivedEvent: {
      type: Function,
      default: () => {},
    },
    cellClickEvent: {
      type: Function,
      default: () => {},
    },
    editClosedEvent: {
      type: Function,
      default: () => {},
    },
    keyID: String,
    shadow: Boolean,
    border: Boolean,
  },
  data() {
    return {};
  },
  watch: {
    data: {
      handler: function (val) {
        // 将form实例返回到父级
        this.$emit("update:refObj", this.$refs.vexForm);
        this.checkBox();
      },
      deep: true, // 深度监听
    },
  },
  mounted() {
    // 将form实例返回到父级
    this.$emit("update:refObj", this.$refs.vexForm);
    this.checkBox();
  },
  //
  methods: {
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    checkboxChange(selection) {
      this.$emit("handleEvent", this.checkboxChangeEvent, selection);
    },
    checkBox() {
      this.$nextTick(() => {
        if (
          this.data &&
          this.fieldList.some((item) => item.type == "checkbox")
        ) {
          this.data.forEach((item) => {
            this.$refs.vexForm.setCheckboxRow(item, item.selected);
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.panel-title .title {
  display: inline;
}
.vxe-toolbar {
  position: absolute;
  top: -15px;
  right: 0;
}
.no-border {
  border: 0;
}
.dialog-panel .no-border .el-card__body {
  padding: 0;
}
.vxe-button--wrapper button {
  margin-left: 5px;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 5px 15px;
}
</style>






// WEBPACK FOOTER //
// src/components/dialog-edit-table.vue